// extracted by mini-css-extract-plugin
export default {"wrapper":"iq-z","response":"jq-z","error":"kq-z","disabled":"lq-z","buttons":"mq-z","feedbackQuestionSection":"nq-z","yesNoWrapper":"oq-z"};